// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ArticleBox{margin-bottom:.875rem;min-height:0;padding-bottom:1.875rem;position:relative}.ArticleBox:after{background-color:#eaeaea;bottom:0;content:\"\";height:1px;left:0;position:absolute;width:100%}.ArticleBox__imageWrapper{margin-bottom:1rem}@media(min-width:1024px){.ArticleBox__imageWrapper{border-bottom-left-radius:.375rem;border-top-left-radius:.375rem;margin-bottom:0;overflow:hidden}}.ArticleBox__perex{max-width:70ch}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
